import React from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

import { sportsbookRoutes } from '@atlas/routing';
import { Icon, Label } from '@atlas/ui';

const SelectionsSportsListItem = ({ onClick, sportPrematchPath }) => {
  const selectionPath = `${sportPrematchPath}/${sportsbookRoutes.selections}`;

  return (
    <NavLink activeClassName="active" className="sports-item" onClick={onClick} to={selectionPath}>
      <div className="sports-item-icon">
        <Icon className="icon-top" name="top" />
      </div>
      <Label className="sports-item-name" message="collections" />
    </NavLink>
  );
};

SelectionsSportsListItem.propTypes = { sportPrematchPath: PropTypes.string.isRequired };

export default SelectionsSportsListItem;
